import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthenticationContext } from "../store/authContext/authContext";
import Sidebar from "./Sidebar";

const NavBar: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState<boolean | null>(null);
  const { state: authContext } = useAuthenticationContext();
  const userData = authContext.userData;
  const route = useLocation();

  useEffect(() => {
    if (userData?.sidebar_settings) {
      setIsExpanded(userData.sidebar_settings.isPinned);
    }
  }, [userData]);

  // The deckbuilder routes should not show the sidebar
  const isDeckBuilderRoute = route.pathname.startsWith("/decks");
  if (isDeckBuilderRoute) {
    return null;
  }

  // Don't render until we know the expanded state
  if (isExpanded === null) return null;

  return <Sidebar isExpanded={isExpanded} onExpandChange={setIsExpanded} />;
};

export default NavBar;
